
<template>
		<div class="yuanh">
			<i-circle
			    :size="150"
			    :trail-width="4"
			    :stroke-width="5"
			    :percent="yh.bl"
			    stroke-linecap="square"
			    stroke-color="#43a3fb"  v-for="yh in yhs" :key="yh.id" style="margin-top: 10px;">
			    <div class="demo-Circle-custom">
			        <h1>{{yh.number}}</h1>
			        <p>{{yh.title}}</p>
			        <span>
			            销售额比例
			            <i>{{yh.bl}}%</i>
			        </span>
			    </div>
			</i-circle>
		</div>
</template>
<script>
    export default {
        data(){
			return {
				
			}
		},
		props:['yhs']
		
    }
</script>
<style lang="less">
	.yuanh{
		display: flex;
		flex-direction: column;
		align-items: center;
	}
    .demo-Circle-custom{
        & h1{
            color: #3f414d;
            font-size: 18px;
            font-weight: normal;
        }
        & p{
            color: #657180;
            font-size: 14px;
            margin: 10px 0 15px;
        }
        & span{
            display: block;
            padding-top: 15px;
            color: #657180;
            font-size: 14px;
            &:before{
                content: '';
                display: block;
                width: 50px;
                height: 1px;
                margin: 0 auto;
                background: #e0e3e6;
                position: relative;
                top: -15px;
            };
        }
        & span i{
            font-style: normal;
            color: #3f414d;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/comm/home/yuanhuan.vue